const en = {
  common: {
    home: 'home',
    email: 'Email address',
    first_name: 'First name',
    last_name: 'Last name',
    password: 'Password',
    repeat_password: 'Repeat password',
    forgot_password: 'Forgot password?',
    new_password: 'New password',    
    old_password: 'Old password',
    change_password: 'Change password',
    cancel: 'Cancel',
    continue: 'Continue',
    success: 'Success!',
    error: 'Error',
    or: 'or',
    back: 'Back',
    signoff: 'Signoff',
    edit: 'Edit',
    actions: 'Actions',
    save: 'Save',
    delete_device: 'Delete Device',
    delete_device_named: 'Delete Device #{name}',
    open_device: 'Open Device',
    view_device: 'View device',
    page: 'Page',
    close: 'Close',
    not_authorized: 'Not Authorized',
    access_denied: 'You do not have permission to access this page.',
    oops: 'Oops!',
    no_access_message: 'It seems you are not authorized to view this resource. Please contact support if you believe this is a mistake.',
    return_home: 'Return to Home',
    next: 'Next',
    previous: 'Previous',
    confirm_delete: 'Are you sure?',
    confirm_delete_message: 'Do you really want to delete this device? This process cannot be undone.',
    delete: 'Delete',
    remove: 'Remove',
    loading: 'Loading...',
    select_all: 'Select All',
    search: 'Search by device name or type',
    search_user: 'Search by user or device',  
    elements_per_page: 'Elements per page', 
    copied: 'Copied to clipboard',
    copy_key: 'Copy Verification Key',
    reload: 'Reload',
    support: 'support',
    successfully_saved: 'Changes saved successfully!',
    password_requirements: 'Your password must meet the following requirements:',
    enter_password: 'Enter your password',
    password_invalid: 'The entered password is invalid.',
    password_weak:'Weak password',
    password_medium:'Medium password',
    password_strong:'Strong password',
    no_results: 'No results found.',
    no_data: 'No data available.',
    open: 'Open',
    yes: 'Yes',
    no: 'No',
    columns: 'Columns',
    apps_services: 'Apps & Services',
    trigger_notification: 'Trigger notification',
    open_externally: 'Open externally',
  },

  errors: {
    global: 'An error occurred.',
    unknown: 'An unknown error occurred.',
    too_many_attempts: 'Too many login attempts. Please try again in {seconds} seconds.',
    could_not_authenticate: 'User could not be authenticated',
    invalid_email: 'Invalid email address',
    no_setup_key: 'No setupKeys found in the response',
    endpoint_not_created_yet: 'Endpoint not created yet.',
    
    accountAwaitsTenantOwnership: "This account is invited to take over ownership of a tenant. It is removed only by deleting that tenant.",
    accountBehindOpenInvitation: "This account belongs to an open invitation. It is removed by withdrawing the invitation.",
    accountDeactivated: "The account at this address is deactivated.",
    accountDeletionPending: "The account at this address is being deleted. The address can be used again only afterwards.",
    adminCannotDeleteOwnAccount: "You cannot delete your own account.",
    alreadyViewer: "This user already has access to the device.",
    accountOwnsDevices: "The account at this address owns devices. An account with its own devices cannot become a member of a tenant.",
    cannotRemoveTenantOwner: "The tenant owner cannot be removed from the tenant. Only a transfer of ownership changes the owner.",
    cannotDeleteTenantOwner: "The account of a tenant owner cannot be deleted. The ownership must be transferred first.",
    memberNotFound: "This person is no longer a member of the tenant.",
    inviteeIsTenantMember: "This address belongs to a member of a tenant. Devices only go to end customers.",
    deviceNotInTenant: "The device no longer belongs to this tenant.",

    authenticationCookieRequired: "Authentication cookie is required.",
    authenticationRequired: "Authentication is required.",
    authenticationRequiredForTopics: "Authentication is required to access these topics.",

    deviceAccessDenied: "You do not have access to this device.",
    deviceIdRequired: "Device ID is required.",
    deviceIdRequiredInUri: "Device ID is required in the request URL.",
    deviceInvalidIpAddress: "The device IP address is invalid.",
    deviceIpNotInAllowedRange: "The device IP address is not in the allowed range.",
    deviceNotFound: "Device not found.",
    deviceNoIpAddress: "The device has no IP address assigned.",
    deviceUnavailable: "The device is currently unavailable.",
    deviceUnreachable: "The device cannot be reached.",

    emailNotVerified: "Your email address is not verified.",
    email_not_verified: 'Your email address is not verified.',
    emailAlreadyExists : "An account with this email already exists.",
    
    fbSignedRequestEmpty: "Facebook signed request is empty.",
    fbSignedRequestInvalidBase64: "Facebook signed request contains invalid Base64 data.",
    fbSignedRequestInvalidPayload: "Facebook signed request payload is invalid.",
    fbSignedRequestMalformed: "Facebook signed request is malformed.",
    fbSignedRequestSignatureMismatch: "Facebook signed request signature mismatch.",

    fcmAccessTokenMissing: "FCM access token is missing.",
    fcmAuthFailed: "Authentication with Firebase Cloud Messaging failed.",
    fcmInvalidPrivateKey: "Invalid Firebase private key.",
    fcmJwtSigningFailed: "Failed to sign Firebase JWT.",

    handledStampNotFound: "Handled stamp not found.",

    headerInvalidType: "Invalid header type.",
    headerNotAllowed: "This header is not allowed.",
    headerValueTooLong: "Header value is too long.",

    httpMethodNotAllowed: "HTTP method not allowed.",

    idpUnexpectedError: "Unexpected error from identity provider.",
    internalError: "Internal server error.",

    invalidCredentials: "Invalid credentials.",
    invalidLogLevel: "Invalid log level.",
    invalidUserClass: "Invalid user class.",
    invitationConflict: "There is an open invitation for this address that conflicts with this. It must be withdrawn first.",

    messageHandlerNoResult: "Message handler returned no result.",

    netbirdApiError: "NetBird API error.",
    netbirdClientRequestFailed: "NetBird client request failed.",
    netbirdEmbeddedGroupNotFound: "NetBird embedded group not found.",
    netbirdRequestFailed: "NetBird request failed.",

    oidcUserCreationFailed: "Failed to create user via OpenID Connect.",

    pathEmpty: "Path must not be empty.",
    pathInvalidStart: "Path has an invalid start.",
    pathTooLong: "Path is too long.",
    pathTraversalNotAllowed: "Path traversal is not allowed.",

    payloadTooLarge: "Payload is too large.",
    rateLimitExceeded: "Rate limit exceeded. Please try again later.",

    requestNotFoundInContext: "Request not found in context.",
    requestRequired: "Request is required.",

    sessionNotFound: "Session not found.",
    sharedDeviceRemoveTenantAccessInstead: "A shared device cannot be removed. Remove the tenant access instead.",

    ssoEmailExists: "An account with this email already exists.",
    ssoMissingIdOrToken: "SSO ID or token is missing.",
    ssoMultipleUsersFound: "Multiple users found for this SSO account.",
    ssoUserIdNotFound: "SSO user ID not found.",

    storageEncodingFailed: "Failed to encode storage data.",
    storageRecordCorrupted: "Stored record is corrupted.",

    technicianNameRequiresTenantMembership: "An internal name can only be set for devices that belong to a tenant.",
    tenantDeviceAccessNotRemovable: "Tenant access cannot be removed from a tenant device.",
    tenantNameAlreadyTaken: "This tenant name is already taken.",
    tenantNameRequired: "Please enter a tenant name.",
    tenantNameTooLong: "The tenant name may have at most 100 characters.",
    tenantAwaitingOwner: "The tenant is still waiting for its owner. This is possible once the owner has accepted the invitation.",
    futureTenantOwnerIsOrgAdmin: "An organization admin cannot become the owner of a tenant.",
    futureTenantOwnerIsOnlyInvited: "The account at this address has not been set up yet. It can become owner once the setup is complete.",

    unauthorized: "You are not authorized to perform this action.",
    unauthorizedRoleAssignment: "You are not allowed to assign this role.",
    insufficientRole: "You do not have permission to perform this action.",

    userDeleteForbidden: "You are not allowed to delete this user.",
    userAlreadyBelongsToTenant: "This user already belongs to a tenant.",
    userIdParameterRequired: "User ID parameter is required.",
    userIdRequired: "User ID is required.",
    userInactive: "This user is inactive.",
    userNotFound: "User not found.",

    zitadelClientRequestFailed: "Zitadel client request failed.",
    zitadelRequestFailed: "Zitadel request failed.",
    zitadelUserNotActive: "Your account is not active. Please contact your administrator.",

    invalid_password: 'The entered password is invalid.',
  },

  verification: {
    invalid_verification_link: 'Invalid verification link.',
    success: 'Your email has been verified successfully.',
    failed: 'Could not be verified: {error}',
    invalid_link: 'Invalid link',
    verifying_account:'Verifying your account...',
    email_not_received: 'Email not recieved?',
    resend_email: 'Resend email',
    sending: 'Sending email',
    resend_email_failed:'Failed to resend verification email.',
    resend_email_email_success:'Verification email sent successfully!',
    email_not_found: 'Email not found',
    error_resending_email: 'Error resending email',
    email_resent:'The verification mail has been send again. If you did not receive any mail from us, please contact {support}.'
  },

  registration: {
    register: 'Register',
    register_now: 'Register now',
    name: 'Name',
    repeat_password: 'Repeat password',
    already_signed_up: 'Already signed up?',
    sign_up: 'Sign up',
    sign_up_subtitle: 'Create an account to manage your devices',
    sign_up_here: 'Sign up here',
    get_started: 'Get started',
    no_account_yet: 'No account yet?',
    log_in_here: 'Log in here',
    check_email: 'Please check your email inbox and confirm your email address.',
    password_changed: 'Password sucessfully changed',
    password_updated: 'Your password has been updated',
    recheck_email: 'You haven’t verified your email address yet. Please verify it to use the app.',
    confirm_email: 'Please confirm Email',
    didnt_receive_email: 'You didn\'t receive an email?',
    user_already_exists: 'User already exists',
    sign_up_error: 'An error occurred during sign-up.',
    check_credentials: 'Please check your credentials.',
    terms_and_conditions: 'I have read the {terms} and conditions and the {privacy} and agree to them.',
    terms: 'terms and conditions',
    privacy: 'privacy policy'
    
  },

  login: {
    login: 'Login',
    auth: 'auth',
    login_or_register: 'Login or Sign Up',
    sign_in: 'Sign in',
    sign_in_subtitle: 'Log in to manage your devices.',
    reset_target_override: 'Reset to default server',
    continue_with_email: 'Continue with email address',
    tell_us_email: 'Tell us the email address of your account',
    login_google: 'Login with Google',
    login_facebook: 'Login with Facebook',
    login_apple: 'Login with Apple',
    enter_the_code: 'Enter the code, we have sent you, here.',
    choose_new_password: 'Choose a new password and continue.',
    wrong_username_password: 'You have entered an invalid username or password',
    passwords_does_not_match: 'The passwords does not match',
    login_instructions: 'We’ve sent an email with instructions to reset your password. Please check your inbox.',
    sign_up: 'Sign Up with email address',
    sign_in_with_email: 'Sign In with Email',
  },

  terms: {
    terms_of_Service: 'Terms of Service',
    privacy_policy: 'Privacy Policy',
    imprint: 'Imprint',
    text: 'by continuing, you agree to our',
    support: 'Support',
  },

  start: {
    welcome: 'Welcome!',
    welcome_msg: 'Quickly and easily manage your energielenker devices. Stay in control, anytime and anywhere.',
    lets_start: 'Let\'s start',
  },

  menu: {
    settings: 'Settings',
    plans: 'Plans',
    home: 'Home',
    admin: 'Admin'
  },

  home: {
    title: 'Your devices',
    subtitle: 'Manage your devices',
    add_device: 'Connect device',
    no_devices: 'You have not linked any devices to your account yet.',
    edit_device: 'Edit device',
    device_name: 'Device Name',
    device_created: 'Enbas created successfully!',
    copy_key: 'Copy the key and enter it into your device.',
    add_another_device: 'Add more Devices',
    apps_title: 'Your Apps',
    apps_subtitle: 'Manage your devices and access them from anywhere.',
    services_title: 'Your Services',
    services_subtitle: 'Choose a service – step by step to the right solution with automatic price calculation.',
    open_solution_builder: 'Open Solution Builder',
    services_choose: 'Choose service',
    cems_subtitle: 'Commercial Energy Management',
    cems_title: 'Solution Builder',
    cems_title_full: 'CEMS Solution Builder',
    cems_description: 'Tool for configuring cloud-based Commercial Energy Management solutions.',
    cems_tags: 'CEMS|Monitoring & Analysis|Energy Roadmap|Load Management',
    eza_subtitle: 'EZA Controllers & Park Controllers',
    eza_title: 'Solution Builder',
    eza_title_full: 'EZA Solution Builder',
    eza_description: 'Configuration of certified EZA controllers according to VDE-AR-N 4105/4110/4120 including licenses, generation plants, commissioning, and hardware options.',
    eza_tags: 'VDE-AR-N 4105|VDE-AR-N 4110/4120|Redispatch|Park Controller',
    org_admin_hint: 'As Organization Admin you find all devices in the device management.',
    org_admin_link: 'Go to device management',
    no_end_customer: 'No end customer yet',
    end_customer: 'End customer: {name} ({email})',
    open_handover: 'Handover to {email} pending',
  },


  admin: {
    title: 'Administration',
    subtitle: 'View all users and their devices',
    manage_org: 'Manage your organization',
    device: 'Device',
    devices: 'Devices',
    tenants: 'Tenants',
    users: 'Users',
    name: 'Name',
    id: 'ID',
    add_tenant: 'Create tenant',
    create_tenant: 'Create tenant',
    tenant_search_placeholder: 'Search tenants',
    user_search_placeholder: 'Search users',
    user_table: {
      name: 'Name',
      role: 'Role',
      tenant: 'Tenant',
      status: 'Status',
      devices: 'Devices',
      devices_breakdown: '{enbas} Enbas / {lobas} Lobas',
    },
    user_overview: {
      title: 'User Overview',
      general_info: 'General information',
      name: 'Name',
      email: 'Email',
      status: 'Status',
      roles_and_tenants: 'Roles and Tenants',
      devices_title: 'Devices',
      devices_subtitle: 'The user has ownership of the following devices.',
      activate: 'Activate',
      deactivate: 'Deactivate',
      cannot_deactivate_self: 'You cannot deactivate your own account.',
      edit_user: 'Edit user',
      delete_user: 'Delete account',
      edit_role: 'Edit role',
      add_tenant_rights: 'Add Tenant Rights',
      toasts: {
        activated: 'User activated.',
        deactivated: 'User deactivated.',
        user_updated: 'User updated.',
        tenant_rights_added: 'Tenant rights added.',
      },
      device_table: {
        device: 'Device',
        type: 'Type',
        status: 'Status',
        owner: 'Owner',
        authorized: 'Authorized',
        users: 'Number of users',
      },
    },
    users_dialogs: {
      invite_user: 'Invite User',
      invite_header: 'Invite a new user',
      edit_user_header: 'Edit user',
      fallback_user: 'user',
      delete_account: {
        header: 'Delete the account of {name}?',
        own_header: 'Delete your account?',
        permanent: 'The account is deleted permanently. This cannot be undone.',
        devices_title: 'These devices will be removed',
        no_devices: 'No devices are removed.',
        unnamed_device: 'Unnamed device',
        tenants_title: 'These tenants lose access to devices',
        no_tenants: 'No tenant loses access.',
        confirm: 'Delete account',
      },
      user_deleted: 'User deleted.',
      choose_tenant: 'Choose tenant',
      choose_tenant_helper:
        'If you invite a technician, you have to assign the user to a tenant.',
      roles: {
        user: 'User',
        user_description:
          'Technicians can manage tenant devices but lack administrative privileges.',
      },
    },
    table: {
      device: 'Device',
      type: 'Type',
      status: 'Status',
      owner: 'Owner',
      tenant: 'Tenant',
      access: 'Access',
      access_users: '{count} user | {count} users',
      name: 'Name',
      label: 'Label',
      internal_name: 'Internal name',
      system_account: 'System account',
      kinds: {
        private: "End customer's device",
        tenant: 'Tenant device',
        shared: 'Shared device',
        system_account: 'Device of the system account',
    },
      load_failed: 'The devices could not be loaded.',
    },
    tenant_form: {
      header: 'Create tenant',
      edit_header: 'Edit tenant',
      name_label: 'Tenant Name',
      name_placeholder: 'New tenant GmbH',
      name_helper: 'Supporting Message',
      owner_title: 'Tenant Owner',
      owner_description: 'Use the tenant owner\'s email address. If they don\'t have an account yet, they\'ll receive an invitation.',
      owner_first_name_placeholder: 'Karl',
      owner_last_name_placeholder: 'Heinz',
      owner_label_helper: 'Supporting Message',
      save_changes: 'Save Changes',
      email_label: 'Email address',
      accounts_notice: 'Devices of customers and of the business belong to a business account. The future owner\'s own devices belong to a separate private account. Connect does not separate the two within one account, so enter the business address.',
      takeover_notice: 'If the address belongs to an existing account, every device of that account becomes a tenant device. Other tenants lose access to them.',
      created_with_owner: 'The tenant {name} was created. {email} is its owner.',
      created_invited: 'The tenant {name} was created. An invitation was sent to {email}; the tenant is waiting for its owner.',
      edit_owner_hint: 'To change the owner, use "Transfer ownership" in the member list.',
    },
    tenant_overview: {
      title: 'Tenant Overview',
      general_info: 'General information',
      name: 'Name',
      enbas_device: 'Enbas device',
      tenant_owner: 'Tenant Owner',
      tenant_email: 'Owner',
      awaiting_owner: 'Awaiting owner',
      awaiting_owner_invited: 'Invited: {email}',
      awaiting_owner_hint: 'You can resend the invitation under "Invitations". It cannot be withdrawn; it only ends when the tenant is deleted.',
      edit_tenant: 'Edit tenant',
      delete_tenant: 'Delete tenant',
      tabs: {
        members: 'Tenant Member',
        devices: 'Devices',
      },
      member_table: {
        name: 'Name',
        role: 'Role',
        status: 'Status',
      },
      member_status: {
        active: 'Active',
        inactive: 'Inactive',
        pending: 'Pending',
      },
      device_table: {
        device: 'Device',
        type: 'Type',
        status: 'Status',
        owner: 'Owner',
        users: 'Number of users',
      },
      member_actions: {
        edit_member: 'Edit member',
        change_role: 'Change role',
        transfer_ownership: 'Transfer ownership',
        remove_member: 'Remove from tenant',
        resend_invitation: 'Resend invitation',
        owner_notice: 'The tenant owner cannot be removed and their role cannot be changed. Only a transfer of ownership changes the owner.',
        owner_transfer_hint: 'To start it, choose "Transfer ownership" on the member who is to become the owner.',
      },
      roles: {
        technician: 'Technician',
        admin: 'Admin',
        tenant_admin: 'Tenant-Admin',
        tenant_owner: 'Tenant-Owner',
        org_admin: 'Org-Admin',
        user: 'User',
      },
      change_role: {
        header: 'Change role',
        subtitle: 'Change the role for {name}.',
        new_role: 'New role',
      },
      remove_member: {
        header: 'Remove from tenant',
        message: 'Remove {name} from the tenant {tenant}? The account remains. {name} loses access to the devices of {tenant} and can be invited again later.',
        confirm: 'Remove from tenant',
      },
      deactivate_confirm: {
        header: 'Deactivate {name}?',
        message: '{name} can no longer sign in. Membership, role and devices remain. You can reactivate the account at any time.',
        confirm: 'Deactivate',
      },
      toasts: {
        invite_sent: 'Invitation sent to {email}. The membership takes effect once the invitation is accepted.',
        member_added: '{email} is now a member of the tenant.',
        invitation_extended: 'The membership was added to the open invitation to {email}. The invitation email has been sent again.',
        role_updated: 'Role updated for {name}.',
        ownership_transferred: 'Ownership transferred to {name}.',
        member_removed: '{name} was removed from the tenant.',
        invitation_resent: 'Invitation resent to {name}.',
        tenant_updated: 'Tenant updated successfully.',
        tenant_deleted: 'Tenant deleted.',
        tenant_deleted_accounts_pending:
          'Tenant deleted. The deletion of {count} account at the identity provider is still pending; it is retried until it succeeds. You find it under "Pending account deletions" in the tenant list. | Tenant deleted. The deletion of {count} accounts at the identity provider is still pending; it is retried until it succeeds. You find them under "Pending account deletions" in the tenant list.',
      },
      invite_member: {
        header: 'Member not found',
        message: 'Would you like to invite {email}?',
        invite: 'Invite ',
      },
      edit_member: {
        header: 'Edit member',
        first_name_label: 'First Name',
        last_name_label: 'Last Name',
        email_label: 'E-Mail address',
        email_helper: 'Supporting message',
        status_label: 'Status',
        role_label: 'Role',
        devices_title: 'Devices',
        devices_description: 'Manage Devices of the user',
        manage_devices: 'Manage Devices',
        services_title: 'Services',
        services_description: 'Manage Services',
        manage_services: 'Manage Services',
      },
      add_member: {
        button: 'Add Member',
        header: 'Add Member',
        user_label: 'Enter the user or email address',
        user_helper: 'Enter the email address of the user to be invited.',
        joins_as_technician: 'New members join as technicians. You can change the role afterwards.',
        choose_role: 'Choose role',
        roles: {
          technician: 'Technician',
          technician_description:
            'Technicians can manage tenant devices but lack administrative privileges.',
          admin: 'Admin',
          admin_description:
            'A tenant admin can manage members and devices, with full access to tenant administration.',
        },
      },
      showing_entries: 'Showing {shown} of {total} entries',
    },
    device_overview: {
      title: 'Device Overview',
      general_info: 'General information',
      name: 'Device Name',
      type: 'Device Type',
      serial_number: 'Device Serial Number',
      copy_serial_number: 'Copy Serial Number',
      owner: 'Device Owner',
      authorized_tenant: 'Authorized Tenant',
      internal_name: 'Internal name',
      status: 'Device Status',
      device_key: 'Device key',
      edit_device: 'Edit Device',
      remove_device: 'Remove Device',
      users_title: 'Users',
      add_user: 'Add user',
      search_placeholder: 'Search users',
      user_table: {
        user: 'User',
        access_level: 'Access level',
  },
      access_levels: {
        owner: 'Owner',
        manage: 'Manage',
        manage_description: 'Can view and control the device.',
        view: 'View only',
        view_description: 'Can only view the device status.',
      },
      actions: {
        edit_user: 'Edit user',
        remove_access: 'Remove access',
      },
      edit_device_dialog: {
        header: 'Edit device',
        name_label: 'Device Name',
      },
      add_user_dialog: {
        header: 'Add user',
        user_label: 'Enter the user or email address',
        user_helper: 'Enter the email address of the user to grant access.',
        choose_access_level: 'Choose access level',
      },
      edit_user_dialog: {
        header: 'Edit user',
      },
      remove_access_dialog: {
        header: 'Remove access',
        message: 'Are you sure you want to remove access for {name}? This action cannot be undone.',
      },
      toasts: {
        device_updated: 'Device updated successfully.',
        device_removed: 'Device removed successfully.',
        user_added: 'User added successfully.',
        user_updated: 'User updated successfully.',
        access_removed: 'Access removed for {name}.',
      },
      showing_entries: 'Showing {shown} of {total} entries',
    },
    pending_account_deletions: {
      heading: 'Pending account deletions ({count})',
      description:
        'These accounts are deleted in Connect but not yet at the identity provider. The deletion is retried until it succeeds; until then the address is blocked.',
      columns: {
        account: 'Account',
        tenant: 'Tenant',
        attempts: 'Failed attempts',
        last_failure: 'Last failure',
      },
      no_failure: '–',
      unknown_tenant: 'unknown',
      load_failed: 'The pending account deletions could not be loaded.',
    },
    tenant_deletion: {
      header: 'Delete tenant {name}',
      consequences: {
        immediate: 'The deletion takes effect immediately.',
        irrevocable: 'It cannot be revoked or undone.',
      },
      state_changed:
        'What the deletion affects has changed since the dialog was opened. Check the current lists and enter the name again.',
      lists: {
        tenant_devices: {
          heading: 'Devices that pass to the system account ({count})',
          empty: 'No devices pass to the system account.',
        },
        shared_devices: {
          heading: 'Shared devices whose access ends ({count})',
          empty: 'No shared devices are affected.',
          item: '{device} – owned by {owner}',
        },
        deleted_accounts: {
          heading: 'Accounts that will be deleted ({count})',
          empty: 'No account will be deleted.',
        },
        kept_accounts: {
          heading: 'Accounts that only lose their membership ({count})',
          empty: 'No account only loses its membership.',
        },
        withdrawn_actions: {
          heading: 'Actions on open invitations that will be withdrawn ({count})',
          empty: 'No action will be withdrawn.',
          kinds: {
            membership: 'Membership for {email}',
            device_handover: 'Handover of {device} to {email}',
            tenant_ownership: 'Tenant ownership for {email}',
          },
        },
      },
      name_label: "Enter the tenant's name to confirm: {name}",
      confirm: 'Delete permanently',
      nothing_changed: 'Nothing was changed.',
      rejections: {
        name_mismatch: "The name entered does not match the tenant's name.",
        tenant_not_found: 'The tenant was not found.',
        not_allowed: 'You are not allowed to delete this tenant.',
        failed: 'The deletion failed. Try again later.',
        outcome_unknown:
          'Whether the tenant was deleted could not be determined. Reload the overview before trying again.',
      },
    },
    tenant_owner_transfer: {
      header: 'Transfer ownership',
      tenant: 'Tenant',
      new_owner: 'New Tenant Owner',
      previous_owner: 'Previous Tenant Owner',
      previous_owner_you: 'You',
      devices: 'Devices passing to the new Tenant Owner ({count})',
      no_devices: 'The tenant has no devices that pass.',
      end_customer_devices_unaffected: 'Devices owned by end customers are not affected.',
      devices_changed:
        'The tenant’s devices changed since the dialog was opened. Check the current list and confirm again.',
      consequences: {
        immediate: 'The transfer takes effect immediately.',
        no_acceptance: 'The new Tenant Owner does not have to accept it.',
        only_new_owner:
          'From then on, only the new Tenant Owner or an Organization Admin can transfer the ownership again.',
        demotion_self: 'You become Tenant Admin and lose the Tenant Owner’s rights.',
        demotion_other: '{name} becomes Tenant Admin and loses the Tenant Owner’s rights.',
      },
      acknowledge_self: 'I understand that I will only be Tenant Admin afterwards.',
      acknowledge_other: 'I understand that {name} will only be Tenant Admin afterwards.',
      confirm: 'Transfer ownership',
      nothing_changed: 'Nothing was changed.',
      rejections: {
        target_is_current_owner: 'This person already is the Tenant Owner.',
        target_is_other_tenant_member: 'This person belongs to another tenant.',
        target_is_only_invited: 'This person is only invited and not yet a member of the tenant.',
        target_inactive: 'This person’s account is deactivated.',
        target_not_found: 'This person is not a member of the tenant.',
        tenant_not_found: 'The tenant was not found.',
        not_allowed: 'You are not allowed to transfer the ownership.',
      },
    },
    device_transfer: {
      header: 'Transfer device',
      kind_label: 'Where should the device be transferred to?',
      kind_tenant: 'To a tenant',
      kind_end_customer: 'To an end customer',
      tenant_filter_placeholder: 'Search tenants by name',
      no_tenants: 'No tenants found.',
      account_search_placeholder: 'Search accounts by name or email',
      no_accounts: 'No account found.',
      no_account_hint:
        'An end customer without an account is reached by handing the device over, not by a transfer.',
      unavailable: {
        own_account: 'Not selectable: this is your own account.',
        inactive: 'Not selectable: the account is deactivated.',
        pending: 'Not selectable: the account has not been activated yet.',
        tenant_member: 'Not selectable: the account belongs to a tenant.',
      },
      show_preview: 'Continue to preview',
      confirm: 'Transfer',
      nothing_changed: 'Nothing was changed.',
      transferred: 'The device was transferred.',
      preview: {
        device: 'Device',
        current_owner: 'Current owner',
        tenant: 'Tenant with access',
        target: 'New owner',
        tenant_owner: 'Tenant Owner',
        losing_access: 'Loses access',
        keeping_access: 'Keeps access',
        open_handover: 'Open handover will be withdrawn',
        tenant_keeps_access:
          'The tenant keeps access to the device. It can be removed afterwards.',
      },
      rejections: {
        target_is_tenant_member: 'The account has meanwhile joined a tenant.',
        target_is_org_admin: 'A device cannot be transferred to an Organization Admin.',
        target_is_system_account: 'A device cannot be transferred to the system account.',
        target_is_current_owner: 'The account already owns the device.',
        target_invalid: 'The chosen target is not valid.',
        target_inactive: 'The account is deactivated.',
        target_not_found: 'The account was not found.',
        tenant_not_found: 'The tenant was not found.',
      },
    },
    device_row_actions: {
      edit_device: 'Edit device',
      transfer_device: 'Transfer device',
      remove_device: 'Remove device',
      edit_dialog: {
        header: 'Edit device',
        name_label: 'Device Name',
        name_helper: 'This is the name visible to the owner and everyone else with access.',
        internal_name_label: 'Internal name',
        internal_name_helper: 'The tenant tag serves as an aid for internal allocation. It is not visible to the owner or anyone outside the tenant.',
      },
      toasts: {
        device_updated: 'Device updated successfully.',
        device_removed: 'Device removed successfully.',
      },
    },
  },


  settings: {
    settings: 'Settings',
    profile: 'Profile',
    app_settings: 'App Settings',
    payment: 'Payment',
    notifications: 'Notifications',
    help: 'Help',
    payment_details: 'Payment Plan and bank details',
    notification_details: 'What notifications do you want to receive',
    profile_details: 'Name and contact details',
    help_details: 'Help, Contact & Terms',
    add_tenant: 'Add Tenant',
    subtitle: 'Name and contact details',
  },

  plans: {
    select_plan: 'Select your plan',
    subtitle: 'Individually tailored to your needs',
    annual_pricing: 'Annual Pricing',
    save_percentage: 'Save {percentage}%',
    free_version: 'Free Version',
    subscribed: 'Subscribed',
    per_month: 'per month',
    manage_devices: 'Manage your devices',
    global_access: 'Global access to devices',
    cloud_optimization: 'Cloud+ Optimization',
    enbas_plus: 'Enbas Plus',
    recommended: 'Recommended'
  },

  payments: {
    title: 'Payments and subscriptions',
    cancel_subscription: 'Cancel subscription',
    enbas_plus: 'Enbas Plus',
    active: 'Active',
    inactive: 'Inactive',
  },

  profile: {
    name: 'Name',
    email: 'E-Mail-Adress',
    edit_profile: 'Edit profile',
    user_profile: 'User Profile',
    edit_your_profile: 'Edit your profile',
    logout: 'Logout',
    notifications: 'Notifications',
    notifications_enabled: 'Enabled',
    notifications_disabled: 'Disabled',
    delete_profile: 'Delete account',
    delete_account_owner_notice: 'As the owner of a tenant you cannot delete your account. Transfer the ownership first.',
    to_member_list: 'Go to the member list',
    type_delete_to_confirm: 'Please write "delete"',
    delete_error: 'An error occurred while deleting the profile. Please try again.',
    language: 'Language',    
    incorrect_old_password: 'The old password you entered is incorrect.',
    password: 'Password',
    change_password: 'Change password',
    current_password: 'Current password',
    edit_email: 'Edit Email Address',
    edit_name: 'Edit Name',
    edit_language: 'Edit Language',
    edit_password: 'Edit Password',
    edit_password_text: 'Enter your current password to change your E-mail address.',
    
  },

  help: {
    title: 'Help',
    terms_of_service: 'Terms of Service',
    privacy_policy: 'Privacy Policy',
    support: 'Support',
    imprint: 'Imprint',
    copyright: 'Copyright energielenker solutions GmbH',
  },

  device: {
    active: 'Active Device',
    all_devices: 'All devices',
    lobas: 'Lobas',
    enbas: 'Enbas',
    device_name: 'Device Name',
    device_updated: 'Device updated successfully!',
    device_name_required: 'Device name is required',
    internal_name: 'Internal name',
    internal_name_helper: 'The tenant tag serves as an aid for internal allocation. It is not visible to the owner or anyone outside the tenant.',
    device_help_before: 'Enter the key in the interface of your device.',
    device_help_link: 'Here',
    device_help_after: 'you can find help on how to do this.',    
    choose_device:'Choose a Device Name and continue.',
    choose_device_title: 'Choose device',
    connect_device:'Connect Device',
    explanation: 'After you tap continue, you will receive an API key that you must enter in the administration interface of your device. Once this is done, the device will be verified, and you will see the device with the status connected in the app.',
    exit_device: 'Exit Device',
    view_mode: 'Currently in Enbas View Mode',
    currently_unavailable: 'Device is currently unavailable (pending or disconnected).',
    first_setup_key: 'First Setup Key',
    device_settings: 'Device settings',
    set_as_default: 'Set as Default Device',
    set_as_default_help: 'This device will open up, if fullscreen Start is activated',
    device_information: 'Device Information',
    device_id: 'Device ID',
    type: 'Type',
    tenant_access: 'Tenant access',
    assigned_tenant: 'Assigned tenant',
    add_tenant: 'Add tenant',
    tenant_assigned: 'Tenant assigned successfully!',
    no_tenant_access: 'No tenant has access to this device',
    removal: {
      device_label: 'Device',
      current_owner: 'Current owner',
      owner: 'Owner',
      losing_access: 'Loses access',
      open_handover: 'Open handover to',
      nothing_changed: 'Nothing was changed.',
      device: {
        action: 'Remove device',
        header: 'Remove device',
        effect: 'The device will be disconnected from energielenker connect. Local settings, measurement data and history remain on the device. It can be paired again later through its own web interface.',
        confirm: 'Remove device',
        done: 'Device removed',
      },
      tenant_access: {
        action: 'Remove our tenant\'s access',
        action_named: 'Remove access of {tenant}',
        header: 'Remove tenant access',
        effect: 'The tenant will no longer see or manage the device and cannot regain access on its own. The device stays with the end customer.',
        confirm: 'Remove access',
        done: 'Tenant access removed',
      },
    },
    device_key: 'Device key',
    key_copied: 'Key copied',
    no_key_tooltip: 'No key available to copy',
    save_settings: 'Save Settings',
    status_changed: "Device {deviceType} {deviceName} status changed from {previousStatus} to {newStatus}",   
    verification_short_key: 'Verification Short Key',    
    explanation_key:'You have already provided the key? It may take a while for the connection to be confirmed.',
    connect_tenant_label: 'Tenant',
    connect_tenant_notice: 'The device will belong to the selected tenant and be owned by its Tenant Owner.',
    handover: {
      start: 'Hand over to end customer',
      title: 'Hand over device to end customer',
      section: 'Handover to end customer',
      status_invited: 'Invited',
      email_label: "End customer's email address",
      invalid_email: 'Please enter a valid email address.',
      check: 'Check',
      device: 'Device',
      recipient: 'Recipient',
      case: {
        immediate: 'There is an account at this address. The handover takes effect immediately.',
        invitation: 'An invitation is sent to this address. The handover takes effect once the end customer accepts it.',
      },
      case_changed: 'How the handover takes effect has changed since the check. Please confirm again.',
      consequences: {
        title: 'What the handover does',
        owner: 'The end customer becomes the owner of the device.',
        tenant_keeps_access: "The device's tenant keeps access until the access is removed.",
        only_access_removable: 'The tenant can then no longer remove the device, only its own access.',
      },
      confirm: 'Confirm handover',
      outcome: {
        immediate: 'The device has been handed over to {email}.',
        invitation: 'An invitation has been sent to {email}. The device passes over once it is accepted.',
        invitation_resent: 'The handover was added to the open invitation to {email}. The invitation email has been sent again.',
      },
      nothing_changed: 'Nothing was changed.',
      rejections: {
        recipient_is_org_admin: 'This address belongs to an Organization Admin. No device can be handed over to them.',
        recipient_is_self: 'You cannot hand over a device to yourself.',
        recipient_is_member: 'This address belongs to a member of a tenant. Devices are handed over to end customers only.',
        account_deactivated: 'The account at this address is deactivated.',
        account_deletion_pending: 'The account at this address is being deleted. The address can be used again only afterwards.',
        invitation_conflict: 'There is an open invitation for this address that conflicts with the handover. It must be withdrawn first.',
        open_handover: 'A handover of this device to {email} is already open. It must be withdrawn first.',
        device_not_found: 'The device was not found.',
        not_allowed: 'You may not hand over this device.',
        invalid_email: 'The email address is invalid.',
      },
    },
    recheck_status: 'Recheck Status',
    device_disconnected: 'Device disconnected',
    device_disconnected_message: 'The connection to your device has been removed. To reconnect, please go to the device settings and enter a new key.',
    status: {
      warning: 'Your device is currently pending verification. This may take a few moments.',
      update: 'Verification pending. Please ensure you\'re using the latest version on your ENBAS.',
      error: 'Failed to establish a connection to the device.',
      info: 'The connection was removed in the device settings.'
    },
    pending: 'Pending',
    connected: 'Connected',
    disconnected: 'Disconnected',
    connection_lost: 'Connection lost',
    connection_failed: 'Update required',
    showing_entries: 'Showing {first}-{last} of {total} entries',
  },

  steps: {
    new_device_title: '1. New Device',
    new_device_description: 'You add a new device in the app.',
    enter_key_title: '2. Enter Key',
    enter_key_description: 'You enter the key in your device settings.',
    ready_to_go_title: 'Done!',
    ready_to_go_description: 'You are ready to go.'
  },

  install_app: {
    install: 'Install our app:',
    open_safari: 'Open Safari,',
    tap: 'tap',
    share: 'Share',
    add_to_home: 'Add to Home Screen',
    better_exp: 'for a better user experience!',
    then: 'then',
  },
  
  optimize: {
    title: 'Want to maximize your device performance?',
    subtitle: 'Get the Full Power of Enbas by Adding an Optimization Plan',
    learn_more: 'Learn More',
    dismiss: 'Dismiss'
  },


  filter:{
    show_disconnected_devices: 'Show disconnected devices',
    show_connected_devices: 'Show connected devices',
    show_also_users_without_devices: 'Include users without devices',
    show_enbas_devices: 'Show ENBAS devices',
    show_lobas_devices: 'Show LOBAS devices',
    filter: 'Filter',    
    search: 'Search',
    remove_filters: 'Reset filters',
    sort_by: 'Sort by',
    device_type: 'Device Type',
    status: 'Status',
    organisation: 'Organisation',
    select_all: 'Select all',
    show_all: 'Show all',
    all: 'All',
    search_columns: 'Search columns',
    sort_options: {
      name: 'First name Last name',
      alphabetical: 'Alphabetical',
    },
    search_by_options: {
      username: 'Username',
      email: 'Email',
      device_name: 'Device name',
      device_serial: 'Serial number',
    },
    search_by_placeholder: 'Search by',
    search_placeholder_generic: 'Search',
    search_placeholders: {
      username: 'Search by username',
      email: 'Search by email',
      device_name: 'Search by device name',
      device_serial: 'Search by serial number',
    },
    types: {
      enbas: 'Enbas',
      lobas: 'Lobas',
    },
    statuses: {
      connected: 'Connected',
      pending: 'Verification pending',
      update_required: 'Update required',
      disconnected: 'Disconnected',
      connection_lost: 'Connection lost',
    },
  },

  notifications: {
    deviceStatusChanged: "Device {deviceId} changed from {from} to {to}",   
    load_error: 'Failed to load notification preferences. Please try again.',
    update_error: 'Failed to update notification preference. Please try again.',
    no_topics: 'No notification topics available.',
    tenant: {
      membership_added: 'You have been added to tenant {tenantName} as {role}.',
      membership_removed: 'You have been removed from tenant {tenantName}.',
      role_changed: 'Your role in {tenantName} has been changed to {role}.',
      ownership_transferred: 'You are now the owner of {tenantName}.',
      renamed: 'The tenant is now called {tenantName}.',
      device_access_removed: '{tenantName} no longer has access to {count} device(s), because their owner now owns a tenant of their own.',
    },
    status: {
      pending_connected: "Your {deviceType} {deviceName} is now successfully connected.",
      connected_disconnected: "Your {deviceType} {deviceName} has been disconnected.",
      disconnected_connected: "Your {deviceType} {deviceName} is connected again.",
      connected_connection_lost: "Your {deviceType} {deviceName} lost connection.",
      connection_lost_connected: "Your {deviceType} {deviceName} has reconnected successfully.",
      update_required_connected: "Your {deviceType} {deviceName} has been updated and is connected again.",
      update_required_disconnected: "Your {deviceType} {deviceName} has been disconnected and still needs an update.",
      connection_lost_disconnected: "Your {deviceType} {deviceName} is no longer reachable and has been disconnected.",
      pending: "Your {deviceType} {deviceName} is pending connection.",
      update_required: "Your {deviceType} {deviceName} requires an update.",
      fallback: "Status update for {deviceType} {deviceName}"
    }
  },

  password: {
    submission_errors: 'There were {errorsNum} errors with your submission',
    password_valid: 'Your submission meets all requirements.', 
     
    password_errors: {
      length: 'Your password must be at least 8 characters',
      uppercase: 'Your password must have at least 1 uppercase letter',
      lowercase: 'Your password must have at least 1 lowercase letter',
      number: 'Your password must have at least 1 number',
      specialChar: 'Your password must have at  least 1 special character',
      mismatch: 'Passwords do not match',
      max_length: 'Password is not too long',
    }
  },

  form: {
    no_errors_in_form: 'Your form meets all requirements.',
    submission_errors: 'There were {errorsNum} errors with your submission',
    errors: {
      invalid_email: 'Invalid email address',
      first_name_short: 'First name is too short',
      last_name_short: 'Last name is too short',
      first_name_too_long: 'First name is too long',
      last_name_too_long: 'Last name is too long',
      email_too_long: 'Email is too long',
      email_required: 'Email address is missing',
    }
  },

  page_titles: {
    welcome: 'Welcome',
    signup_login: 'Sign Up or Login',
    sign_up: 'Sign Up',
    sign_in: 'Sign In',
    signup_success: 'Registration Successful',
    forgot_password: 'Forgot Password',
    reset_password: 'Reset Password',
    user_verify: 'Verify User',
    edit_password: 'Change Password',
    edit_name: 'Change Name',
    edit_email: 'Change Email',

    plans: 'Plans',
    profile: 'Profile',
    edit_profile: 'Edit Profile',
    notifications: 'Notifications',
    help: 'Help',
    payments: 'Payment Methods',
    settings: 'Settings',
    home: 'Devices',
    edit_device: 'Edit Device',
    not_authorized: 'Not Authorize',
    sso_success: 'SSO Login Successful',
    sso_fail: 'SSO Login Failed',
    admin: 'Administration',
  },
  offline: {
    headline: 'We\'ll be back shortly!',
    message: 'Our system is currently undergoing maintenance to provide you with an even better experience soon. Please check back later.',
  },
  layout: {
    collapse_sidebar: 'Collapse sidebar',
    expand_sidebar: 'Expand sidebar',
  },
  navigation: {
    system_status: 'System status',
  },
  tenant_owner_notice: {
    header: 'You are the owner of {tenantName}',
    message: 'Devices of your customers and of your business belong in this business account. Your own devices belong in a separate private account. Connect does not separate the two within one account.',
    confirm: 'Got it',
  },
  invitations: {
    tab: 'Invitations',
    platform_title: 'Open invitations',
    empty: 'There are no open invitations.',
    tenant: 'Tenant',
    end_customer: 'End customer',
    attached_by: 'Attached by',
    attached_by_unknown: 'Attached by an account that no longer exists',
    invited_on: 'Invited on',
    last_sent_on: 'Last sent on',
    resend: 'Resend',
    ownership_ends_with_tenant:
      'The invitation to take over ownership cannot be withdrawn. Only deleting the tenant ends it.',
    filter: {
      tenants: 'Tenants',
      end_customer: 'End customers',
    },
    actions: {
      membership: 'Member (technician) of {tenant}',
      device_handover: 'Handover of device {device}',
      tenant_ownership: 'Ownership of {tenant}',
    },
    withdraw: {
      button: 'Withdraw',
      header: 'Withdraw invitation',
      message: 'The invitation to this address will be withdrawn. This ends:',
      confirm: 'Withdraw',
    },
    toasts: {
      resent: 'Invitation resent to {email}.',
      withdrawn: 'Invitation to {email} withdrawn.',
    },
    errors: {
      not_resendable: 'This invitation cannot be resent.',
      not_open: 'This invitation is no longer open.',
      ownership_not_withdrawable: 'An invitation to take over ownership cannot be withdrawn.',
      resent_too_soon: 'This invitation was just sent. Please try again in a minute.',
      not_allowed: 'You are not allowed to do this.',
      not_found: 'The invitation was not found.',
    },
  },
};

export default en;
